module.exports = __webpack_public_path__ + "media/concert.175b9e05.mp4";